import type { ReactNode } from 'react';
import Button from '../../form/Button';
import { ModalFormFooter } from './Modal';
import { usePartialConfigOnClose } from './partialConfigModalUtils';

export function PartialConfigModalFooter({ children }: { children?: ReactNode }) {
    const onClose = usePartialConfigOnClose();

    return (
        <ModalFormFooter>
            <Button
                type="button"
                variant="secondary"
                className="px-4 py-2 text-sm"
                onClick={onClose}
            >
                {gettext('CANCEL')}
            </Button>
            {children}
        </ModalFormFooter>
    );
}
